'use client';

import React from 'react';
import StoreCart from './StoreCart';
import useCartStore from '@/src/lib/state-stores/cartStore';
import EmtyCart from './EmtyCart';
import NotFound from '@/src/components/NotFound';
import LoadingCart from './LoadingCart';
import { useTranslations } from 'next-intl';
import { useGetCart } from '../services/clientApi';

// ---------------- Fetch All Carts Hook ----------------
const useFetchCarts = () => {
  const { carts, setCarts } = useCartStore();
  const { data, isLoading, isError } = useGetCart(); // API واحدة

  React.useEffect(() => {
    if (data) setCarts(data);
  }, [data, setCarts]);

  return { carts, isLoading, isError };
};

// ---------------- Main Component ----------------
const ListOfCarts = ({
  onCloseCartSheet,
  isSlide,
}: {
  onCloseCartSheet?: () => void;
  isSlide?: boolean;
}) => {
  const t = useTranslations('error');

  const { carts, cartId } = useCartStore();
  const { isLoading, isError } = useFetchCarts();

  // ---------- View Single Cart from List ----------
  const selectedCart = carts.find((cart) => String(cart.id) === String(cartId));

  if (cartId) {
    if (isLoading) return <LoadingCart />; // loading if carts not loaded yet
    if (isError) return <NotFound title={t('wrong')} />;
    if (!selectedCart) return <EmtyCart onCloseCartSheet={onCloseCartSheet} isSlide={isSlide} />;

    return <StoreCart carts={[selectedCart]} onCloseCartSheet={onCloseCartSheet} />;
  }

  // ---------- Render All Carts ----------
  if (isLoading) return Array.from({ length: 3 }).map((_, i) => <LoadingCart key={i} />);

  if (isError) return <NotFound title={t('wrong')} />;

  if (!carts?.length) return <EmtyCart onCloseCartSheet={onCloseCartSheet} isSlide={isSlide} />;

  return <StoreCart carts={carts} onCloseCartSheet={onCloseCartSheet} />;
};

export default ListOfCarts;
